import React, { Component } from 'react'

class EditItemField extends Component {

    constructor(props) {
        super()
        this.state = {
            item: props.item
        }
    }

    setFocus() {
        let input = document.getElementById("edit-publication-item-field");
        input.focus();
    }

    renderErrors = (error) => {
        return (
            <ul className="flex-centered shake-on-error" id="form-errors">
                {error}
            </ul>
        );
    }

    handleChange = (e) => {
        if (this.props.errors.length > 0) {
            this.props.clearFormErrors()
        }
        this.setState({ item: e.target.value })
    }

    handleSubmit = (e) => {
        e.preventDefault()
        if (!this.state.item) {
            return this.props.submitFormError("An Item Cannot Be Blank")
        }

        if (this.props.item === this.state.item) {
            this.props.cancel()
        }

        this.props.submitItemChange(this.state.item)
    }

    render() {
        return <li>
            <form onSubmit={this.handleSubmit} onBlur={this.props.cancel} id="edit-publication-item-form">
                <input
                    id="edit-publication-item-field"
                    className="max-width flex"
                    type="text"
                    placeholder="Rename Your Item"
                    value={this.state.item}
                    onChange={this.handleChange}
                />
                {this.props.errors.length > 0 ? this.renderErrors(this.props.errors) : null}
            </form>
        </li>
    }
}

export default EditItemField